module.exports = {
  model: {id: '', name: '', code: '', customer_id: null}
}
